import React from "react";
import SideBar from "../../components/sidebar/Sidebar";
import { useCreateUrlHook } from "./hook";
import validator from 'validator'
import { Form } from "react-bootstrap";
import { useListHook } from "../Admin/List/hook";
import { useUpdateStatus } from "../Admin/Modal/ClientsAssign/hook";
import UserLoginData from "../Auth/UserLoginData";
import { toast } from "react-hot-toast";
import { FaCross } from "react-icons/fa";
import { FiLink2 } from "react-icons/fi";

export const CreateShortUrlScreenName = "create-short-url";

export const CreateShortUrlScreen = () => {

  const { isLoggedIn } = UserLoginData()

  const { doSubmitUrl, otherDetails, setOtherDetails, handleInputChange } = useCreateUrlHook();
  const { urlData } = otherDetails;

  const handleOnchangeInputs = (e) => {
    const value = e.target.value
    const name = clientList.find(x => x._id === value)
    setOtherDetails({ ...otherDetails, clientName: name ? name.username : "", clientId: value })
  }

  // showing all client list
  const { clientList } = useListHook();

  const { defaultData } = useUpdateStatus(isLoggedIn && isLoggedIn.response._id);
  const selectableClients = isLoggedIn && isLoggedIn.response.role !== "admin" ? defaultData : clientList;

  React.useEffect(() => {
    if (otherDetails.clientId || selectableClients.length === 0) return;

    const firstClient = selectableClients[0];
    setOtherDetails((details) => ({
      ...details,
      clientId: firstClient._id,
      clientName: firstClient.username
    }));
  }, [otherDetails.clientId, selectableClients, setOtherDetails]);

  const handleSubmitUrl = (e) => {
    e.preventDefault();

    if (validator.isURL(urlData)) {
      if (otherDetails.clientId !== "") {
        doSubmitUrl({
          url: urlData,
          title: otherDetails.title ? otherDetails.title : "No Title Added",
          clientId: otherDetails.clientId,
          clientName: otherDetails.clientName,
          description: otherDetails.description ? otherDetails.description : "No Description Provided",
          utm_source: (otherDetails.tinySource).split(','),
          utm_medium: (otherDetails.tinyMedium).split(','),
          utm_campaign: (otherDetails.tinyCampaign).split(','),
          utm_term: (otherDetails.tinyTerm).split(','),
          utm_content: (otherDetails.tinyContent).split(','),
          loginUserId: isLoggedIn && isLoggedIn.response._id
        });
      } else {
        toast("Please select client", {
          duration: 2000,
          icon: <FaCross />,
          style: {
            backgroundColor: "var(--surface-raised)",
            fontSize: 14,
          },
        });
      }

    } else {
      toast("Please enter valid url", {
        duration: 2000,
        icon: <FaCross />,
        style: {
          backgroundColor: "var(--surface-raised)",
          fontSize: 14,
        },
      });
    }

  };

  return (
    <SideBar>
      <section className="create-page" aria-labelledby="create-page-title">
        <header className="create-page-header">
          <span className="create-page-icon" aria-hidden="true"><FiLink2 /></span>
          <div>
            <h1 id="create-page-title">Create short link</h1>
            <p>Add a destination URL and assign it to a client.</p>
          </div>
        </header>

        <form className="create-form">
          <div className="create-form-grid">
            <div className="create-field">
              <label htmlFor="url_website">Destination URL</label>
              <input
                type="url"
                value={urlData}
                className="form-control"
                id="url_website"
                onChange={handleInputChange}
                name="urlData"
                placeholder="https://example.com/page"
              />
            </div>
            <div className="create-field">
              <label htmlFor="create-title">Link title</label>
              <input
                type="text"
                value={otherDetails?.title ?? ""}
                id="create-title"
                name="title"
                className="form-control"
                placeholder="e.g. Campaign landing page"
                onChange={handleInputChange}
              />
            </div>
            <div className="create-field">
              <label htmlFor="create-client">Client</label>
              <Form.Select
                id="create-client"
                name="clientName"
                className="form-control"
                value={otherDetails.clientId}
                onChange={handleOnchangeInputs}>
                <option value="">Select a client</option>
                {selectableClients.map((client) => (
                  <option value={client._id} key={client._id}>{client.username}</option>
                ))}
              </Form.Select>
            </div>
            <div className="create-field create-field-wide">
              <label htmlFor="create-description">Description <span>Optional</span></label>
              <textarea
                id="create-description"
                name="description"
                value={otherDetails?.description ?? ""}
                className="form-control"
                placeholder="Add a short note about this link"
                onChange={handleInputChange}
                rows="4"
              />
            </div>
          </div>
          <div className="create-form-actions">
            <button type="button" className="create-submit" onClick={handleSubmitUrl}>Create link</button>
          </div>
        </form>
      </section>
    </SideBar>
  );
};
